config:
  history:
    bullets: true
name:
  firstName: Shawn
  nickName: Wookiee
  lastName: Parker
  title: Tech Lead / Staff Engineer with 20+ years of experience
contact:
  address:
    streetAddress: null
    locality: Castle Pines
    region: CO
    postalCode: '80108'
    countryName: USA
  methods:
    email: shawn@topfroggraphics.com
    telFormatted: null
    telE164: null
    urls:
    - https://top-frog.com
    - https://github.com/Gipetto
buzzwords:
- - name: Migrations where nobody notices.
    text: Shadow systems and parity reconcilers keep the cutovers quiet. Success
      looks like an unremarkable deploy log.
  - name: Growing Engineers.
    text: Project/tech specs, planning, mentoring — bringing early-career
      engineers up to owning their systems.
  - name: Python, Java, PHP, Scala, Golang.
    text: The language is a detail; just write tests for it!
  - name: TypeScript/JavaScript, SvelteKit, Next.js, React, Node.
    text: We still love you, jQuery! But we love Svelte more...
  - name: I18n, L10n, A11y.
    text: I’ve learned more than I ever thought I wanted to know about character sets,
      locales, and externalization.
  - name: PDF Generation & Printing.
    text: Taking HTML to Print/PDF and building PDFs from PDF templates.
# - name: WordPress Contributor.
#   text: Mostly bug fixes and small enhancements to the WP Core, but its all for
#     the greater good, right?
- - name: WordPress Plugin Maintainer.
    text: Post Password Token, est. September, 2009
links:
- icon: linkedin
  href: https://www.linkedin.com/in/shawnparker
  text: LinkedIn Profile
- icon: github
  href: https://github.com/Gipetto/resume
  text: View source of this Resume.
sameAs:
- https://flickr.com/photos/tehgipster
- https://www.quizstreak.com/u/Wookiee
- https://poocherino.com
- https://hachyderm.io/@wookieeboy
objective:
- Tech lead / staff engineer with 20+ years turning fuzzy product asks into dependable
  systems, across startups, scale-ups, and client shops. I’ve taken apart monoliths
  more than once, built the services that replace them, and carried the pager through
  the transition. I’ve led projects from concept to launch, improved system reliability,
  and mentored engineers. I move slow and fix things.
sideProject:
  name: QuizStreak
  url: https://www.quizstreak.com
  description:
  - "QuizStreak is a daily trivia game by a two-person team: my partner creates
    the questions and runs the business, and I build and run everything technical
    on SvelteKit and Supabase."
  - Past day 900 of continuous daily play, with roughly 370 weekly-active players —
    kept fast by a handful of NPM packages and hand-written CSS.
howIUseAgents:
  items:
  - title: Done is defined first.
    description: I sign off on acceptance criteria before any code gets written.
  - title: Separate hands.
    description: Planning, implementing, verifying, and reviewing are different agents
      with narrow permissions. The reviewer checks the diff against the criteria,
      not the implementer’s summary.
  - title: I hold the keys.
    description: Pushes, PRs, and anything destructive wait for my approval.
  config:
    text: My personal AI agent config
    url: https://github.com/Gipetto/opencode-config
currentWork:
- company: QuizStreak
  location: Castle Pines, CO
  url: https://www.quizstreak.com
  positions:
  - from:
      month: 10
      year: 2023
    title: Lead Developer / Co-owner
    description:
    - Build a daily trivia game on SvelteKit, Supabase, and hand-written CSS, keeping
      dependencies minimal so the app stays fast on any device.
    - Generate in-depth statistics suitable for user rankings, comparisons, and automated
      league categorization.
    - Conduct user behavior analysis and customer interviews to identify feature opportunities
      and improve engagement.
  hidden: true
- company: Wander.com
  location: Austin, TX
  remote: true
  url: https://www.wander.com
  hideUrl: true
  positions:
  - from:
      month: 12
      year: 2025
    title: Team Lead / Software Engineer IV
    description:
    - "Lead extraction of the Property domain from the monolith into a dedicated system of record, deliberately keeping search and business logic out; serving teams including booking, payments, search, and front end."
    - "Run the migration with zero downtime: dual writes, a reconciler comparing both systems around the clock, and authoritative reads cut over field by field. Issues have been limited to data consistency, resolved without large-scale recovery."
    - "Shipped a leaner listing API on the new system of record: payloads down ~80%, cached guest API median latency down 47%, uncached host-site p99 down 57% in benchmarks, with the migration’s shadow-merge hop still in the request path."
    - "Own production reliability during the parallel run: incident response, latency diagnosis, and repair of inconsistencies, including uncovering undocumented legacy behavior and encoding it as explicit contracts."
workHistory:
- company: Culture Foundry
  location: Seattle, WA
  remote: true
  url: https://www.culturefoundry.com
  hideUrl: true
  positions:
  - from:
      month: 3
      year: 2024
    to:
      month: 12
      year: 2025
    title: Software Engineer, Contractor
    description:
    - Built custom web applications and sites for clients across industries, working in
      Next.js, Python, Django, Golang, and WordPress.
    - Built responsive, accessible interfaces from design mockups in Bootstrap and
      Tailwind CSS, and extended WordPress with custom themes and plugins.
    - Partnered with project managers and clients to turn requirements into scoped technical
      plans and deliverables.
    - Implemented CI/CD pipelines for deployment and testing across WPEngine and
      client-managed hosting.
- company: Career Break
  positions:
  - description:
    - Launched a trivia game (quizstreak.com) on SvelteKit and Supabase, covering modern
      web development, game design, and statistics.
    - Learned Kubernetes by building local clusters from scratch — how they work, not
      just how to use them.
    - Stepped away after 11 years in startups to recharge and retool before returning
      to full-time work.
- company: RevOps
  location: Berkeley, CA
  remote: true
  url: https://www.revops.io
  hideUrl: true
  positions:
  - from:
      month: 4
      year: 2022
    to:
      month: 3
      year: 2023
    title: Lead Software Engineer
    description:
    - Led a small engineering team building product growth features, coordinating with
      Product, Sales, and Support on what to build and why.
    - Architected and implemented a full-stack solution for complex, dynamic pricing
      models, building the backend logic in Python and the customer-facing configuration
      interface in React and TypeScript.
    - Supervised remote contractors in finalizing a company-wide Design System, establishing
      consistent design patterns and enforcing high code quality standards across
      the front-end codebase.
    - Improved core web vitals and user experience by analyzing browser bundle composition
      and optimizing dependencies, resulting in an approximately 10% reduction in
      application build size.
- company: Twilio
  location: San Francisco, CA
  url: https://www.twilio.com
  hideUrl: true
  positions:
  - from:
      month: 7
      year: 2019
    to:
      month: 1
      year: 2022
    title: Staff Software Engineer / Tech Lead, Growth Engineering
    description:
    - Designed fault-tolerant systems that supported multiple teams in onboarding new
      members and accelerating product adoption.
    - Mentored engineers on project and task management, engineering best practices,
      problem-solving, and code quality.
    - Oversaw remote contractors and streamlined team productivity by clarifying expectations
      and task definitions.
  - from:
      month: 6
      year: 2011
    to:
      month: 7
      year: 2019
    title: Senior Software Engineer 1 & 2
    description:
    - "Worked across four product teams: Growth Engineering, Experimentation Platform,
      Phone Numbers, and Console."
    - Built a custom-built customer data platform, integrated into the experimentation
      platform, that let teams make run-time decisions about their customers based on
      live data and computed metrics.
    - Brought the company into compliance with international phone number regulations
      via a patented workflow that provisions numbers against country-specific rules.
    - Deconstructed a monolithic PHP codebase so individual teams could own their
      development lifecycles, reduce contention over core sections, and grow their own
      back-end services.
    - Drove a culture of testing as a normal part of the development lifecycle.
    - Increased adoption of technologies and tooling to improve system observability
      and drive down recovery time from errors.
  patents:
  - type: U.S. Patent
    number: 11,153,390 B2
    issued: Oct. 19, 2021
    title: Multi-Jurisdictional Endpoint Allocation Compliance
    description:
    - A system for evaluating and verifying jurisdictional eligibility to allocate
      resources based on identification data and regulatory rule sets.
- company: Crowd Favorite
  location: Denver, CO
  positions:
  - from:
      month: 5
      year: 2008
    to:
      month: 6
      year: 2011
    title: Senior Developer
    description:
    - Built custom solutions on and for WordPress as a publishing platform.
    - Wrote requirements and plans for work ranging from plugin development to API
      integrations to large-scale deployments.
    - Engineered CodeIgniter-based systems on Amazon cloud services to scale high-volume,
      time-sensitive data processing.
  hidden: true
- company: Alternative Technology
  location: Englewood, CO
  positions:
  - from:
      month: 11
      year: 2003
    to:
      month: 5
      year: 2008
    title: Web Developer & Designer
    description:
    - Maintained the client-facing website and client portal for a hardware, software,
      and technical services distributor.
    - Built a custom framework for managing product information, client portal access,
      and educational class schedules.
    - Provided the marketing team with tools to help efficiently develop client communications.
  hidden: true
education:
- description: Bachelor’s Degree in Visual Arts
  date:
    month: 12
    year: 1996
  institution: University of Northern Colorado, Greeley, Colorado
everydayTools:
  title: Everyday Tools
  items:
    - JSON
    - YAML
    - TOML
    - XML
    - Bash
    - Zsh
    - Git
    - grep
    - Nix
    - NixOS
    - ripgrep
    - SQL
    - SSH
    - cron
    - regular expressions
    - jq
    - tmux
    - Vim
    - Linux
    - macOS
    - Docker
    - Docker Compose
    - OpenAPI
robotData:
- title: Languages and Runtimes
  headers:
  - title: Language/Runtime
    dataKey: title
  - title: Start Year
    dataKey: start
  - title: End Year
    dataKey: end
  items:
  - title: Deno
    start: 2019
    end: present
  - title: Golang (Go)
    start: 2015
    end: present
  - title: Java
    start: 2014
    end: 2018
  - title: JavaScript
    start: 1999
    end: present
  - title: NPM
    start: 2014
    end: present
  - title: PHP
    start: 2002
    end: present
  - title: PHP-FPM
    start: 2013
    end: 2021
  - title: Python
    start: 2010
    end: present
  - title: Rust
    start: 2020
    end: 2023
  - title: Scala
    start: 2015
    end: 2020
  - title: TypeScript
    start: 2015
    end: present
- title: Markup Languages
  headers:
  - title: Language
    dataKey: title
  - title: Start Year
    dataKey: start
  - title: End Year
    dataKey: end
  items:
  - title: CSS
    start: 1998
    end: present
  - title: HTML
    start: 1998
    end: present
  - title: Less
    start: 2013
    end: 2016
  - title: Markdown
    start: 2008
    end: present
  - title: Sass
    start: 2012
    end: present
- title: Language Frameworks
  headers:
  - title: Framework
    dataKey: title
  - title: Start Year
    dataKey: start
  - title: End Year
    dataKey: end
  items:
  - title: Bootstrap
    language: CSS
    start: 2013
    end: present
  - title: CodeIgniter
    language: PHP
    start: 2008
    end: 2010
  - title: Django
    language: python
    start: 2015
    end: 2020
  - title: Laravel
    language: PHP
    start: 2014
    end: 2018
  - title: Next.js
    language: JavaScript/TypeScript
    start: 2025
    end: present
  - title: React
    language: JavaScript/TypeScript
    start: 2015
    end: present
  - title: Svelte
    language: JavaScript/TypeScript
    start: 2019
    end: present
  - title: SvelteKit
    language: JavaScript/TypeScript
    start: 2019
    end: present
  - title: Tailwind
    language: CSS
    start: 2024
    end: present
  - title: Wagtail
    language: Python
    start: 2020
    end: 2025
  - title: WordPress
    language: PHP
    start: 2008
    end: present
- title: Databases
  headers:
  - title: Name
    dataKey: title
  - title: Start Year
    dataKey: start
  - title: End Year
    dataKey: end
  items:
  - title: Elasticsearch
    start: 2016
    end: 2022
  - title: Firestore
    start: 2022
    end: 2023
  - title: PostgreSQL
    start: 2012
    end: present
  - title: MySQL
    start: 2000
    end: present
  - title: RDS
    start: 2013
    end: 2022
  - title: SQLite
    start: 2009
    end: present
- title: Key/Value Stores
  headers:
  - title: Name
    dataKey: title
  - title: Start Year
    dataKey: start
  - title: End Year
    dataKey: end
  items:
  - title: ElastiCache
    start: 2013
    end: 2019
  - title: Memcached
    start: 2008
    end: 2014
  - title: Redis
    start: 2017
    end: 2022
- title: SaaS/Cloud Services
  headers:
  - title: Service
    dataKey: title
  - title: Start Year
    dataKey: start
  - title: End Year
    dataKey: end
  items:
  - title: AWS
    start: 2009
    end: 2022
  - title: Bugsnag
    start: 2022
    end: 2023
  - title: Datadog
    start: 2013
    end: 2022
  - title: Google Cloud
    start: 2022
    end: 2023
  - title: Resend
    start: 2023
    end: present
  - title: SendGrid
    start: 2018
    end: 2022
  - title: Sentry
    start: 2018
    end: present
  - title: Supabase
    start: 2023
    end: present
  - title: Twilio
    start: 2011
    end: 2022
- title: Infrastructure / Deployment
  headers:
  - title: System
    dataKey: title
  - title: Start Year
    dataKey: start
  - title: End Year
    dataKey: end
  items:
  - title: Apache
    start: 2002
    end: present
  - title: Fly.io
    start: 2026
    end: present
  - title: HAProxy
    start: 2011
    end: present
  - title: Kubernetes
    start: 2022
    end: present
  - title: Nginx
    start: 2012
    end: present
  - title: Terraform
    start: 2020
    end: 2022
  - title: Vercel
    start: 2020
    end: present
aiTools:
- title: Codex CLI
  usage: Primary coding agent & harness
- title: OpenCode
  usage: Primary coding agent harness for local & personal work
- title: Claude
  usage: Regular use
- title: Cursor
  usage: Team tool
- title: Adapt
  usage: Internal company assistant; org-wide knowledge search and PR review
- title: OpenRouter
  usage: Model gateway; configured agent-based PR review
- title: oMLX
  usage: Local OpenAI-compatible model server on Apple Silicon; offline inference for agents
- title: LM Studio
  usage: Local inference
- title: Kindex
  usage: Cross-agent persistent memory graph; decisions and codebase facts survive sessions
- title: Signet
  usage: Agent guardrails; permission hooks and policy rules gate destructive commands
- title: Simulacrum
  usage: Adversarial review harness; attacks ideas and plans with concrete scenarios before commitment
- title: Advocate
  usage: Six-persona review engine; parallel red-team, peer, and user-perspective findings on diffs and designs
- title: GitNexus
  usage: Code knowledge graph; impact analysis and execution-flow tracing before every edit
agentPractices:
- title: Spec-first development
  detail: AI helps write specs; agents start with few or no open questions
- title: Architect / implementer split
  detail: Engineer designs and reviews; agent implements
- title: Focused agents
  detail: Separate plan, implement, verify, and review agents with scoped permissions
- title: Acceptance criteria
  detail: Human-ratified before implementation; independent review against them
- title: Approval gates
  detail: Push, PR, and destructive actions require human approval
- title: Version-controlled agent config
  detail: Public example at github.com/Gipetto/opencode-config
- title: CLI over MCP
  detail: CLI tools preferred over MCP servers where both exist
- title: Local model evaluation
  detail: Quantization, context sizing, and dense vs MoE for coding workloads
- title: Mentoring
  detail: Established engineering habits applied to agent-assisted work
